import { Row, Col, Button } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { JustRightHeightModal } from 'components/styled/scoped';
import { css } from '@emotion/css';
import { produce } from 'immer';
import { useTranslate } from '@tolgee/react';
import PresetTimeImpl from './PresetTimeImpl';
import useTimeRange from './useTimeRange';
import PresetTimePreview from './PresetTimePreview';

type PresetTimeProps = {
  value: number[];
  onChange: (val: number[]) => void;
};

function PresetTime(props: PresetTimeProps) {
  const { value, onChange } = props;
  const { t } = useTranslate();
  const [visible, setVisible] = useState(false);
  const [openIt, modalInstance2] = useTimeRange();
  const close = useCallback(() => setVisible(false), []);
  const [selectedIds, setSelectedIds] = useState<number[]>(value);
  const onCardSelect = useCallback((id) => {
    setSelectedIds(
      produce((draft) => {
        if (draft.includes(id)) {
          draft.splice(draft.indexOf(id), 1);
        } else {
          draft.push(id);
        }
      }),
    );
  }, []);

  useEffect(() => {
    if (!visible) {
      setSelectedIds(value);
    }
  }, [visible, setSelectedIds, value]);

  const modalInstance = (
    <JustRightHeightModal
      visible={visible}
      onCancel={close}
      width={638}
      destroyOnClose
      centered
      className={css`
        .ant-modal-body {
          margin: 0 !important;
          padding: 0;
        }
      `}
      title={t('knowledge.选择预定义时间段')}
      footer={
        <Row align="middle" justify="space-between">
          <Col style={{ cursor: 'pointer' }} onClick={() => openIt()}>
            + {t('knowledge.新增时间段')}
          </Col>
          <Col>
            <Row gutter={16} align="middle">
              <Col>{t('voucher.已选x', { x: selectedIds.length })}</Col>
              <Col>
                <Button
                  type="primary"
                  onClick={() => {
                    onChange?.(selectedIds);
                    close();
                  }}
                >
                  {t('department.确认选择')}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      }
    >
      {modalInstance2}
      <PresetTimeImpl ids={selectedIds} onCardSelect={onCardSelect} />
    </JustRightHeightModal>
  );

  return (
    <div>
      <PresetTimePreview ids={value} />
      <div
        className="text-[14px] leading-[20px] cursor-pointer text-[#336fff] mt-[8px]"
        onClick={() => setVisible(true)}
      >
        + {t('knowledge.选择预定义时间段')}
      </div>
      {modalInstance}
    </div>
  );
}

export default PresetTime;
